import { render, staticRenderFns } from "./CharMulti.vue?vue&type=template&id=65c64eb6&"
import script from "./CharMulti.vue?vue&type=script&lang=js&"
export * from "./CharMulti.vue?vue&type=script&lang=js&"
import style0 from "./CharMulti.vue?vue&type=style&index=0&id=65c64eb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports